/*
 * skywalking 主动上报方法
 * @param category 类型
 * @param grade 级别
 * @param error Error 对象
 */
export const reportError = (
  error: Error | CustomError | unknown,
  category: ErrorCategory = 'js',
  grade: GradeType = 'Warning',
): void => {
  window.ClientMonitor
    && window.ClientMonitor.reportFrameErrors(
      {
        category,
        grade,
      },
      error,
    );
};

/**
 * 动态域名配置 注意资源引入 //s.thsi.cn/cd/ths-frontend-common-lib-container/v1.3.20/business/dynamicDomain.js
 * @param configUrl 需要切换备用域名的地址
 * @returns 切换之后的地址
 */
export function getUrlByPromise(configUrl: string): Promise<string> {
  return new Promise<string>(resolve => {
    if (getEnvStatus().isDev) {
      resolve(configUrl);
    } else {
      try {
        // 切换
        window.dynamicDomain.exchangeHost(configUrl, (url: string) => {
          url ? resolve(url) : resolve(configUrl);
        });
      } catch (error) {
        resolve(configUrl);
      }
    }
  });
}

/**
 * 获取当前环境状态 dev开发环境  test测试环境  release正式环境
 * @returns 返回当前
 */
export function getCurrentEnvMode(): string {
  // 获取当前环境属性 设置可能的值规范
  return process.env.VUE_APP_CURRENTMODE as env;
}

/**
 * 获取当前环境的状态判断
 * @returns 当前环境的判断
 */
export function getEnvStatus(): envObj {
  const env = getCurrentEnvMode();
  return {
    isDev: env === 'dev',
    isTest: env === 'test',
    isRelease: env === 'release',
  };
}

/**
 * 获取过期时间
 * @param day 过期天数
 * @returns 过期时间戳
 */
export const getDayZeroTimestamp = (day: number): number => {
  // 获取当前时间
  const currentDate = new Date();
  // 设置为明天
  currentDate.setDate(currentDate.getDate() + day);
  // 将时间设置为零点
  currentDate.setHours(0, 0, 0, 0);
  // 返回明天零点的时间戳
  return currentDate.getTime();
};
